import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { BaseDialog, BaseDialogProps } from '../BaseDialog/BaseDialog';

export type SingleTabBaseDialogProps = Omit<
  BaseDialogProps<'default'>,
  'activeTabName' | 'onTabSelected' | 'children'
> & {
  title: string;
};

/**
 * An easier to use version of the BaseDialog if you only want a single tab
 */
export const SingleTabBaseDialog: FunctionComponent<SingleTabBaseDialogProps> =
  React.memo((props) => {
    const { title, children, ...remainingProps } = prepareProps({ props });

    return (
      <BaseDialog<'general'>
        {...remainingProps}
        activeTabName="general"
      >
        {() => ({
          general: {
            name: 'general',
            title,
            renderContent: () => children
          }
        })}
      </BaseDialog>
    );
  });
